export default __webpack_public_path__ + "static/media/meuPortifolio.baccebe2.svg";